/* eslint-disable react/no-unknown-property */
import Enllac from 'components/3catinfo/Enllac';
import __isEmpty from 'lodash/isEmpty';
import 'swiper/css';
import 'swiper/css/free-mode';
import { dataResources } from 'utils/constants';

const { basePath } = dataResources;

const _itemsSeo = (items) => {
    return items?.map((item, index) => {
        return (
            <div key={`llistat-notis-seu-${index}`}>
                <Enllac href={item.url} titol={item.text} />
            </div>
        );
    });
};

const MenuAmp = (props) => {
    const { itemsSeo = {} } = props;
    return (
        <>
            <style jsx>{`
                .headerbar {
                    background-color: #ff8135;
                    display: flex;
                    padding-left: 8px;
                }
                .menu {
                    background: #ffffff;
                    width: 33%;
                    min-width: 200px;
                }
            `}</style>
            <style global jsx>{`
                @font-face {
                    font-family: 'Bw 3cat';
                    src:
                        url(/_resources/fonts/Bw3Cat-Regular.woff2?v=JIT_ENV_RESOURCES_VERSION) format('woff2'),
                        url(/_resources/fonts/Bw3Cat-Regular.woff?v=JIT_ENV_RESOURCES_VERSION) format('woff');
                    font-weight: 400;
                    font-style: normal;
                    font-display: block;
                }
                @font-face {
                    font-family: 'Bw 3cat';
                    src:
                        url(/_resources/fonts/Bw3Cat-Medium.woff2?v=JIT_ENV_RESOURCES_VERSION) format('woff2'),
                        url(/_resources/fonts/Bw3Cat-Medium.woff?v=JIT_ENV_RESOURCES_VERSION) format('woff');
                    font-weight: 500;
                    font-style: normal;
                    font-display: block;
                }
                @font-face {
                    font-family: 'Bw 3cat';
                    src:
                        url(/_resources/fonts/Bw3Cat-Bold.woff2?v=JIT_ENV_RESOURCES_VERSION) format('woff2'),
                        url(/_resources/fonts/Bw3Cat-Bold.woff?v=JIT_ENV_RESOURCES_VERSION) format('woff');
                    font-weight: 700;
                    font-style: normal;
                    font-display: block;
                }
                @font-face {
                    font-family: 'Bw 3cat';
                    src:
                        url(/_resources/fonts/Bw3Cat-Black.woff2?v=JIT_ENV_RESOURCES_VERSION) format('woff2'),
                        url(/_resources/fonts/Bw3Cat-Black.woff?v=JIT_ENV_RESOURCES_VERSION) format('woff');
                    font-weight: 900;
                    font-style: normal;
                    font-display: block;
                }
                @font-face {
                    font-family: 'Bw 3cat';
                    src:
                        url(/_resources/fonts/Bw3Cat-RegularItalic.woff2?v=JIT_ENV_RESOURCES_VERSION) format('woff2'),
                        url(/_resources/fonts/Bw3Cat-RegularItalic.woff?v=JIT_ENV_RESOURCES_VERSION) format('woff');
                    font-weight: 400;
                    font-style: italic;
                    font-display: block;
                }
                body {
                    font-family: 'Bw 3cat', sans-serif;
                }
                .sr-only {
                    position: absolute;
                    width: 1px;
                    height: 1px;
                    margin: -1px;
                    padding: 0;
                    overflow: hidden;
                    clip: rect(0, 0, 0, 0);
                    border: 0;
                }
                .menuCorporate {
                    background: #000;
                    display: flex;
                    padding-left: 8px;
                }
                .menuLogoCorporate {
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    margin-left: 10px;
                }
                .menuLogo {
                    height: 56px;
                    display: flex;
                    justify-content: center;
                    margin-left: 10px;
                }
                .menuLogo amp-img,
                .menuLogoCorporate amp-img {
                    margin: auto;
                }
                .amp-menuseo {
                    background: #21292c;
                    min-width: calc(100% - 68px);
                    max-width: calc(100% - 68px);
                    height: 25px;
                    overflow: hidden;
                    display: block;
                    padding: 0 34px;
                }
                .amp-carousel-slide {
                    height: 25px;
                }
                .amp-carousel-button.amp-carousel-button-next {
                    background-color: transparent;
                    right: 0;
                    background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M6.73963 21.4112C6.73939 21.3342 6.75437 21.2579 6.78371 21.1867C6.81305 21.1155 6.85618 21.0507 6.9106 20.9962L15.8411 11.9993L6.91227 3.00368C6.85777 2.94885 6.8146 2.88383 6.78523 2.81232C6.75586 2.74081 6.74087 2.66421 6.7411 2.58691C6.74156 2.43078 6.80403 2.28124 6.91476 2.17117C7.02549 2.06111 7.17541 1.99954 7.33153 2C7.48765 2.00047 7.6372 2.06294 7.74726 2.17366L17.089 11.5852C17.1988 11.6954 17.2605 11.8446 17.2605 12.0002C17.2605 12.1557 17.1988 12.305 17.089 12.4152L7.7456 21.8263C7.66344 21.909 7.55856 21.9654 7.44428 21.9884C7.32999 22.0114 7.21145 22 7.10368 21.9555C6.99591 21.9111 6.90378 21.8356 6.83896 21.7387C6.77415 21.6418 6.73957 21.5278 6.73963 21.4112Z" fill="white"/></svg>');
                    background-size: 16px 16px;
                }
                .amp-carousel-button.amp-carousel-button-prev {
                    background-color: transparent;
                    left: 0;
                    background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.2605 2.58875C17.2607 2.66578 17.2457 2.7421 17.2164 2.81332C17.187 2.88454 17.1439 2.94925 17.0895 3.00376L8.15897 12.0007L17.0878 20.9963C17.1423 21.0512 17.1855 21.1162 17.2149 21.1877C17.2442 21.2592 17.2592 21.3358 17.259 21.4131C17.2585 21.5692 17.1961 21.7188 17.0853 21.8288C16.9746 21.9389 16.8247 22.0005 16.6686 22C16.5124 21.9995 16.3629 21.9371 16.2528 21.8263L6.91105 12.4148C6.80126 12.3046 6.73962 12.1554 6.73962 11.9998C6.73962 11.8443 6.80126 11.695 6.91105 11.5848L16.2545 2.17374C16.3367 2.09104 16.4415 2.0346 16.5558 2.01158C16.6701 1.98857 16.7886 2.00001 16.8964 2.04447C17.0042 2.08893 17.0963 2.1644 17.1611 2.26131C17.2259 2.35821 17.2605 2.47217 17.2605 2.58875Z" fill="white"/></svg>');
                    background-size: 16px 16px;
                }
                .amp-menuseo a {
                    color: #a1aeb2;
                    font-size: 10px;
                    line-height: 14px;
                }
                .amp-menuseo::-webkit-scrollbar {
                    display: none;
                }
                .amp-menuseo {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
            `}</style>
            <amp-carousel width='400' height='25' className='amp-menuseo'>
                {_itemsSeo(itemsSeo)}
            </amp-carousel>
            <nav aria-label='Menú corporatiu' className='menuCorporate' id='navegacio'>
                <Enllac href='/3cat/' className='menuLogoCorporate'>
                    <amp-img
                        width={56}
                        height={16}
                        alt='Logo 3Cat'
                        src={basePath + '/_resources/logos/3cat_color.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
            </nav>
            <nav className='headerbar'>
                <Enllac href='/3catinfo/' className='menuLogo'>
                    <amp-img
                        width={111}
                        height={26}
                        alt='Logo 3CatInfo'
                        src={basePath + '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                    />
                </Enllac>
            </nav>
        </>
    );
};

export default MenuAmp;
